module.exports = __webpack_public_path__ + "881deaed4d91f2f760977925929d17c2.png";